'use server';

import { createClient } from '@/lib/supabase/server';
import { revalidatePath } from 'next/cache';

/** Org-wide color scheme: classic (amber) vs valencia (red/yellow).
 *  Mirrors packages_mode_enabled pattern (app_settings upsert). */

export type BrandScheme = 'classic' | 'valencia';

const KEY = 'brand_scheme';

export async function getBrandScheme(): Promise<BrandScheme> {
  const supabase = await createClient();
  const { data } = await supabase
    .from('app_settings')
    .select('value')
    .eq('key', KEY)
    .maybeSingle();
  return data?.value === 'classic' ? 'classic' : 'valencia';
}

export async function setBrandScheme(scheme: BrandScheme): Promise<void> {
  const supabase = await createClient();
  const { error } = await supabase
    .from('app_settings')
    .upsert({
      key: KEY,
      value: scheme,
      updated_at: new Date().toISOString(),
    });
  if (error) throw new Error(error.message);
  revalidatePath('/staff/admin');
  revalidatePath('/', 'layout');
}
